var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cms-block-stub"},[_c('small',{staticClass:"cms-block-stub__name"},[_vm._v("ContactsBlock")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.values.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }